import { FieldNames } from 'app/models/fields/names';
import { ovInquiryQuestionById, ovInquiryQuestionsByName } from 'app/models/questions/ov-loan-inquiry';
import { Section } from 'app/models/types';
import {
  OV_INQUIRY_APP_PERSONAL_INFORMATION,
  OV_INQUIRY_FINAL_PAGE_QUESTION,
  OV_INQUIRY_FINAL_SECTION,
  OV_INQUIRY_GET_LOAN_INFORMATION,
  OV_INQUIRY_GET_VEHICLE_TYPE,
} from './constants';
import { submitOtherVehicleInquiry } from 'app/actions/form/actions';

export const getOVInquirySectionById = (id: number): Section => {
  return OV_INQUIRY_SECTIONS.find((section) => section.id === id) as Section;
};

const OV_INQUIRY_SECTIONS: Section[] = [
  {
    id              : OV_INQUIRY_GET_VEHICLE_TYPE,
    questions       : ovInquiryQuestionsByName([
      FieldNames.vehicleType,
      FieldNames.vehicle,
    ]),
    hideBackButton  : true,
    hideProgressBar : true,
  },
  {
    id       : OV_INQUIRY_GET_LOAN_INFORMATION,
    questions: ovInquiryQuestionsByName([
      FieldNames.purchasePrice,
      FieldNames.downDollar,
      FieldNames.loanTermDesired,
    ]),
  },
  {
    id       : OV_INQUIRY_APP_PERSONAL_INFORMATION,
    title    : 'Enter your personal information',
    questions: ovInquiryQuestionsByName([
      FieldNames.firstName,
      FieldNames.middleName,
      FieldNames.lastName,
      FieldNames.suffixName,
      FieldNames.email,
      FieldNames.phone,
      FieldNames.dateOfBirth,
    ]),
    submitAction: submitOtherVehicleInquiry,
    submitText: 'Submit',
  },
  {
    id                : OV_INQUIRY_FINAL_SECTION,
    questions         : [ovInquiryQuestionById(OV_INQUIRY_FINAL_PAGE_QUESTION)],
    hideBackButton    : true,
    hideForwardButton : true,
    hideProgressBar   : true,
  },
];
